(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["amberis-hero"] && !Shopify.designMode) return;
  try {
    
  class AmberisHero extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-amberis-hero-track]');
      if (!this.track) return;

      this.slides = Array.from(this.querySelectorAll('[data-amberis-hero-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-amberis-hero-goto]'));
      this.current = 0;

      const prev = this.querySelector('[data-amberis-hero-prev]');
      const next = this.querySelector('[data-amberis-hero-next]');
      if (prev) prev.addEventListener('click', () => this.go(this.current - 1));
      if (next) next.addEventListener('click', () => this.go(this.current + 1));

      this.dots.forEach((dot) => {
        dot.addEventListener('click', () => this.go(parseInt(dot.dataset.amberisHeroGoto, 10) - 1));
      });

      this.track.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.go(this.current - 1);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.go(this.current + 1);
        }
      });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                this.current = this.slides.indexOf(entry.target);
                this.sync();
              }
            });
          },
          { root: this.track, threshold: 0.6 }
        );
        this.slides.forEach((slide) => this.observer.observe(slide));
      }

      this.sync();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    go(index) {
      if (!this.slides.length) return;
      const target = (index + this.slides.length) % this.slides.length;
      this.slides[target].inert = false;
      this.track.scrollTo({ left: this.slides[target].offsetLeft - this.track.offsetLeft });
      this.current = target;
      this.sync();
    }

    sync() {
      const active = this.slides[this.current];
      if (active) this.dataset.scheme = active.dataset.scheme || 'light';

      this.slides.forEach((slide, index) => {
        slide.inert = index !== this.current;
      });

      this.dots.forEach((dot, index) => {
        if (index === this.current) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

    }
  }

  if (!customElements.get('amberis-hero')) {
    customElements.define('amberis-hero', AmberisHero);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
